import React, { Component } from 'react'
import modalType from './ModalHOC'
import { ALertHeaderText, AlertText } from './styles'
import IconButton from 'material-ui/IconButton'
import Avatar from 'material-ui/Avatar'
import FlatButton from 'material-ui/FlatButton'
import Room from 'material-ui/svg-icons/action/group-work'
import Clear from 'material-ui/svg-icons/content/clear'
import TextField from 'material-ui/TextField'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import { List, ListItem } from 'material-ui/List'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import config from '../../config/config'

export class MoveModal extends Component {

  render () {
    return (
      <div>
        <div
          style={{borderBottom: '1px solid #6B7C93'}}
          className='flex justify-between items-center pa3'>
          <ALertHeaderText className='flex items-center'>
            <Avatar
              src={this.props.move_direct ? 'https://' + config.API_HOST + '/api/v1/image/' + this.props.move_name : 'https://' + config.API_HOST + '/api/v1/image/' + this.props.move_user_id}/>
            <div className='pl3'>
              <div style={{fontSize: 16}} className='pb1'>
                <FormattedMessage id='main.modalMoveTitle1'/> {this.props.move_name} <FormattedMessage
                id='main.modalMoveTitle2'/>
              </div>
              <div style={{fontSize: 12}}>
                <FormattedMessage id='main.modalMoveAssignTitle'/> {this.props.move_table}
              </div>
            </div>
          </ALertHeaderText>
          <div>
            <IconButton onClick={this.props.handleClose} iconStyle={{fill: '#afb8c5'}}>
              <Clear/>
            </IconButton>
          </div>
        </div>
        <List className='vh-75 overflow-auto'>
          {this.props.tableList.map((val, index) => (
            <ListItem
              key={index}
              disabled
              style={{maxHeight: 64, borderBottom: '1px solid #d9d9d9'}}
              leftIcon={
                <div
                  className='justify-center items-center'
                  style={{width: 40, height: 40, borderRadius: '100%', backgroundColor: '#2D92EE', display: 'flex'}}>
                  <Room style={{fill: '#FFFFFF'}}/>
                </div>}>
              <div className='flex items-center justify-between'>
                <div>
                  <div style={{fontSize: 16, color: '#6B7C93'}} className='pb1'>
                    {val.name}
                  </div>
                  <div style={{fontSize: 12, color: '#6B7C93', opacity: 0.55}}>
                    {(typeof this.props.groupListObj[val.group] != 'undefined') ? (this.props.groupListObj[val.group].length) : (0)}
                    <FormattedMessage id='main.members'/>
                  </div>
                </div>
                <div>
                  {this.props.move_group != val.group &&
                  <div> {(typeof this.props.groupListObj[val.group] != 'undefined') ? (
                    (this.props.groupListObj[val.group].length > 5) ? (
                      <FlatButton label={<FormattedMessage id='main.modalMoveFull'/>}
                                  labelStyle={{color: '#F01631'}}/>) : (
                      <FlatButton onClick={() => {
                        this.props.joinVideo(this.props.move_uid, this.props.move_name, val.group, this.props.move_user_id, this.props.move_role, this.props.move_direct)
                        this.props.handleClose()
                      }} label={<FormattedMessage id='main.modalMoveEnter'/>} labelStyle={{color: '#2D92EE'}}/>)
                  ) : (<FlatButton onClick={() => {
                    this.props.joinVideo(this.props.move_uid, this.props.move_name, val.group, this.props.move_user_id, this.props.move_role, this.props.move_direct)
                    this.props.handleClose()
                  }} label={<FormattedMessage id='main.modalMoveEnter'/>} labelStyle={{color: '#2D92EE'}}/>)
                  } </div>}
                  {this.props.move_group == val.group &&
                  <div className='flex items-center'>
                    <div
                      className='pr2'
                      style={{fontSize: 12, color: '#6B7C93', opacity: 0.55}}>
                      <FormattedMessage id='main.modalMoveAssign'/>
                    </div>
                    <CheckCircle style={{fill: '#29B87A'}}/>
                  </div>
                  }

                </div>
              </div>
            </ListItem>
          ))}
        </List>
      </div>
    )
  }
}

export class DeleteTable extends Component {

  handleSubmit = (name, group) => {
    this.props.deleteTable(group)
    this.props.snackbarOpen('', `${name} Table deleted`)
    this.props.handleClose()
    console.log(this.props)
  }

  render () {
    return (
      <div>
        <div
          style={{borderBottom: '1px solid #6B7C93'}}
          className='flex justify-between items-center pa3'>
          <ALertHeaderText className='flex items-center'>
            <FormattedMessage id='main.modalDeleteTitle'/>
          </ALertHeaderText>
          <div>
            <IconButton onClick={this.props.handleClose} iconStyle={{fill: '#afb8c5'}}>
              <Clear/>
            </IconButton>
          </div>
        </div>
        <List className='vh-75 overflow-auto'>
          {this.props.tableList.map((val, index) => (
            <ListItem
              key={index}
              disabled
              style={{maxHeight: 64, borderBottom: '1px solid #d9d9d9'}}
              leftIcon={
                <div
                  className='justify-center items-center'
                  style={{width: 40, height: 40, borderRadius: '100%', backgroundColor: '#2D92EE', display: 'flex'}}>
                  <Room style={{fill: '#FFFFFF'}}/>
                </div>}>
              <div className='flex items-center justify-between'>
                <div>
                  <div style={{fontSize: 16, color: '#6B7C93'}} className='pb1'>
                    {val.name}
                  </div>
                  <div style={{fontSize: 12, color: '#6B7C93', opacity: 0.55}}>
                    {(typeof this.props.groupListObj[val.group] != 'undefined') ? (this.props.groupListObj[val.group].length) : (0)}
                    <FormattedMessage id='main.members'/>
                  </div>
                </div>
                <div>
                  <FlatButton
                    onClick={() => {this.handleSubmit(val.name, val.group)}}
                    label={<FormattedMessage id='main.delete'/>}
                    labelStyle={{color: '#F01631'}}
                  />
                </div>
              </div>
            </ListItem>
          ))}
        </List>
      </div>
    )
  }
}

export const EndCall = ({handleClose}) => (
  <div style={{padding: 24}}>
    <div
      className='flex justify-between items-center mb4'>
      <ALertHeaderText className='flex items-center'>
        End Breakout Session?
      </ALertHeaderText>
      <div>
        <IconButton onClick={handleClose} iconStyle={{fill: '#afb8c5'}}>
          <Clear/>
        </IconButton>
      </div>
    </div>
    <div>
      <AlertText className='mb3'>
        Are you sure you want to END the entire call?
      </AlertText>
      <ALertHeaderText style={{lineHeight: 1.5}} className='mb4'>
        The breakout sessions along with the main seminar will end.
      </ALertHeaderText>
      <div className='flex justify-end'>
        <div className='w4'>
          <FlatButton
            label='cancel'
            labelStyle={{color: '#AFB8C4'}}
            fullWidth
            onClick={handleClose}
          />
        </div>
        <div className='ml2 w6 mb3'>
          <FlatButton
            label='end entire call'
            fullWidth
            backgroundColor='#F01631'
            labelStyle={{color: '#FFFFFF'}}
            onClick={handleClose}
          />
        </div>
      </div>
    </div>
  </div>
)

export const ReturnToSeminar = ({handleClose, redirectToSeminarMode}) => (
  <div style={{padding: 24}}>
    <div
      className='flex justify-between items-center mb4'>
      <ALertHeaderText className='flex items-center'>
        <FormattedMessage id='main.modalSeminarTitle'/>
      </ALertHeaderText>
      <div>
        <IconButton onClick={handleClose} iconStyle={{fill: '#afb8c5'}}>
          <Clear/>
        </IconButton>
      </div>
    </div>
    <div>
      <AlertText className='mb3' style={{color: '#29B87A'}}>
        <FormattedMessage id='main.modalSeminarBody'/>
      </AlertText>
      <div className='flex justify-end'>
        <div className='w4'>
          <FlatButton
            label={<FormattedMessage id='main.cancel'/>}
            labelStyle={{color: '#AFB8C4'}}
            fullWidth
            onClick={handleClose}
          />
        </div>
        <div className='ml2 w6 mb3'>
          <FlatButton
            label={<FormattedMessage id='main.modalSeminarEnter'/>}
            fullWidth
            hoverColor='#12603e'
            backgroundColor='#29B87A'
            labelStyle={{color: '#FFFFFF'}}
            onClick={() => {
              redirectToSeminarMode()
              handleClose()
            }}
          />
        </div>
      </div>
    </div>
  </div>
)

export class CreateTable extends Component {
  state = {
    name: '',
    nameError: null
  }

  handleChange = (e) => this.setState({name: e.target.value, nameError: false})

  handleSubmit = (e) => {
    e.preventDefault()
    const {name} = this.state

    if (name.length === 0) {
      return this.setState({nameError: true})
    }

    var same_flag = false
    this.props.tableList.map((val, index) => {
      if (name == val.name) {
        same_flag = true
      }
    })
    if (same_flag) {
      return this.setState({nameError: true})
    }

    this.props.snackbarOpen(e, `${name} Table created`)
    this.props.createTable(name)
    this.props.handleClose()
  }

  render () {
    return (
      <div style={{padding: 24}}>
        <div
          className='flex justify-between items-center mb2'>
          <ALertHeaderText className='flex items-center'>
            <FormattedMessage id='main.modalCreateTableTitle'/>
          </ALertHeaderText>
          <div>
            <IconButton onClick={this.props.handleClose} iconStyle={{fill: '#afb8c5'}}>
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <div className='mb3'>
            <TextField
              fullWidth
              floatingLabelStyle={{color: '#afb8c5'}}
              onChange={this.handleChange}
              value={this.state.name}
              errorText={(this.state.nameError) ? (<FormattedMessage id='main.modalCreateProhibitSameName'/>) : null}
              underlineFocusStyle={{borderColor: '#29B87A'}}
              hintText='text'
              floatingLabelText={<FormattedMessage id='main.modalCreateTableName'/>}/>
          </div>
          <div className='flex justify-end mb3'>
            <div className='w4'>
              <FlatButton
                label={<FormattedMessage id='main.cancel'/>}
                labelStyle={{color: '#AFB8C4'}}
                fullWidth
                onClick={this.props.handleClose}
              />
            </div>
            <div className='ml2 w6'>
              <FlatButton
                label={<FormattedMessage id='main.modalCreateTableEnter'/>}
                fullWidth
                hoverColor='#279867'
                backgroundColor='#29B87A'
                labelStyle={{color: '#FFFFFF'}}
                onClick={this.handleSubmit}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export class AssignRandom extends Component {
  state = {
    name: '',
    nameError: null
  }

  handleChange = (e) => this.setState({name: e.target.value, nameError: false})

  handleSubmit = (e) => {
    e.preventDefault()
    const {name} = this.state

    if (name != parseInt(name, 10)) {
      return this.setState({nameError: true})
    }

    if (name.length === 0) {
      return this.setState({nameError: true})
    }

    this.props.randomHandle(name)
    this.props.handleClose()
  }

  render () {
    return (
      <div style={{padding: 24}}>
        <div
          className='flex justify-between items-center mb2'>
          <ALertHeaderText className='flex items-center'>
            <FormattedMessage id='main.modalAssignTitle'/>
          </ALertHeaderText>
          <div>
            <IconButton onClick={this.props.handleClose} iconStyle={{fill: '#afb8c5'}}>
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <div className='mb3'>
            <TextField
              fullWidth
              floatingLabelStyle={{color: '#afb8c5'}}
              onChange={this.handleChange}
              value={this.state.name}
              errorText={(this.state.nameError) ? (<FormattedMessage id='main.fieldEmptyNum'/>) : null}
              underlineFocusStyle={{borderColor: '#29B87A'}}
              hintText='1'
              floatingLabelText={<FormattedMessage id='main.modalAssignText'/>}/>
          </div>
          <div className='flex justify-end mb3'>
            <div className='w4'>
              <FlatButton
                label={<FormattedMessage id='main.cancel'/>}
                labelStyle={{color: '#AFB8C4'}}
                fullWidth
                onClick={this.props.handleClose}
              />
            </div>
            <div className='ml2 w6'>
              <FlatButton
                label={<FormattedMessage id='main.modalAssignEnter'/>}
                fullWidth
                hoverColor='#279867'
                backgroundColor='#29B87A'
                labelStyle={{color: '#FFFFFF'}}
                onClick={this.handleSubmit}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export class SendAnnouncement extends Component {
  state = {
    announcement: '',
    announcementError: null
  }

  handleChange = (e) => this.setState({announcement: e.target.value, announcementError: false})

  handleSubmit = (e) => {
    e.preventDefault()
    const {announcement} = this.state

    if (announcement.length === 0) {
      return this.setState({announcementError: true})
    }
    this.props.snackbarOpen(e, `${this.props.name} announced`)
    this.props.handleChat(announcement, moment().format('hh:mm a'), true)
    this.props.handleClose()
  }

  render () {
    return (
      <div>
        <div
          style={{borderBottom: '1px solid #6B7C93', padding: 24}}
          className='flex justify-between items-center mb2'>
          <ALertHeaderText
            className='flex items-center'>
            <FormattedMessage id='main.modalAnnounceTitle'/>
          </ALertHeaderText>
          <div>
            <IconButton onClick={this.props.handleClose} iconStyle={{fill: '#afb8c5'}}>
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div style={{borderBottom: '1px solid #6B7C93', padding: 24, height: 400}}>
          <TextField
            fullWidth
            floatingLabelStyle={{color: '#afb8c5'}}
            onChange={this.handleChange}
            rows={4}
            multiLine
            value={this.state.announcement}
            errorText={(this.state.announcementError) ? (<FormattedMessage id='main.fieldEmpty'/>) : null}
            underlineFocusStyle={{borderColor: '#29B87A'}}
            floatingLabelText={<FormattedMessage id='main.modalAnnounceBody'/>}/>
        </div>
        <div
          className='flex justify-end items-center'
          style={{height: 84, paddingLeft: 24, paddingRight: 24}}>
          <div className='w4'>
            <FlatButton
              label={<FormattedMessage id='main.cancel'/>}
              labelStyle={{color: '#AFB8C4'}}
              fullWidth
              onClick={this.props.handleClose}
            />
          </div>
          <div className='ml2 w6'>
            <FlatButton
              label={<FormattedMessage id='main.modalAnnounceEnter'/>}
              fullWidth
              backgroundColor='#FDD868'
              labelStyle={{color: '#8F7527'}}
              onClick={this.handleSubmit}/>
          </div>
        </div>
      </div>
    )
  }
}

const Modal = ({children}) => (
  <div>
    {children}
  </div>
)

export default modalType(Modal)



// WEBPACK FOOTER //
// ./src/routes/BreakOutMode/Modals.js